import Icon from '@salesforce/design-system-react/components/icon';
import PageHeader from '@salesforce/design-system-react/components/page-header';

interface ProjectsHeaderProps {
  title: string;
}
const ProjectsHeader = ({ title }: ProjectsHeaderProps) => {
  return (
    <>
      <PageHeader
        icon={
          // <Icon
          //   assistiveText={{ label: 'Projects' }}
          //   category="standard"
          //   name="list_email"
          // />
          <div>
            <img
              src="/assets/dartagnan-logo.png"
              style={{ borderRadius: '4px' }}
            />
          </div>
        }
        //info="6 Items • Updated 13 minutes ago"
        label="Dartagnan Connector"
        // onRenderActions={actions}
        // onRenderControls={controls}
        title={title}
        variant="object-home"
      />
    </>
  );
};

export default ProjectsHeader;
